import { Capability } from './device-capability';
import branding from 'shared/app/model/branding';
function hasCap(cap) {
    return (caps) => caps.includes(cap);
}
export const EventFilters = [
    {
        id: 'ztc-signalization',
        title: 'Сигнализация',
        children: [
            {
                id: 'alarm',
                title: 'Тревога',
                capsPred: hasCap(Capability.has_guard_state),
            },
            { id: 'power', title: 'Вкл / Выкл' },
            {
                id: 'alarmbutton',
                title: 'Тревожная кнопка',
                capsPred: hasCap(Capability.has_alarm_button),
            },
            {
                id: 'main_power',
                title: 'Пропадание/появление основного питания',
                capsPred: hasCap(Capability.has_battery),
            },
            {
                id: 'batterylow',
                title: 'Разряд аккумулятора',
                capsPred: hasCap(Capability.has_battery),
            },
            {
                id: 'guard',
                title: 'Постановка/снятие с охраны',
                capsPred: (caps) => caps.includes(Capability.has_guard_state) ||
                    caps.includes(Capability.has_optional_guard),
            },
            {
                id: 'shock',
                title: 'Срабатывание датчика удара',
                capsPred: hasCap(Capability.has_accelerometer),
            },
            // { id: 'doors', title: 'Открытие/закрытие дверей', require_devcaps: 'has_car_sensors' },
            // { id: 'hood', title: 'Открытие/закрытие капота', require_devcaps: 'has_car_sensors' },
            // { id: 'trunk', title: 'Открытие/закрытие багажника', require_devcaps: 'has_car_sensors' },
            // { id: 'alarmignition', title: 'Тревога по зажиганию', require_devcaps: 'has_car_sensors' },
            // { id: 'alarmtilt', title: 'Тревога по наклону', require_devcaps: 'has_accelerometer' },
            {
                id: 'autoignition',
                title: 'Автозапуск',
                capsPred: hasCap(Capability.has_car_controls),
            },
            {
                id: 'engineblock',
                title: 'Блокировка двигателя',
                capsPred: hasCap(Capability.has_car_controls),
            },
            {
                id: 'engine',
                title: 'Состояние двигателя',
                capsPred: hasCap(Capability.has_car_controls),
            },
            {
                id: 'carinputs',
                title: 'Дополнительные статусы',
                capsPred: branding.code === 'autoscan'
                    ? (caps) => caps.includes(Capability.has_car_sensors) &&
                        caps.includes(Capability.has_autoscan_settings)
                    : hasCap(Capability.has_car_sensors),
            },
            // { id: 'moving', title: 'Движение автомобиля', require_devcaps: 'has_accelerometer' },
            {
                id: 'blackout',
                title: 'Глушение GSM-сигнала',
                capsPred: hasCap(Capability.has_gsm),
            },
            {
                id: 'radiofobadded',
                title: 'Добавлено радиоустройство',
                capsPred: hasCap(Capability.has_rf_fobs),
            },
        ],
    },
    {
        id: 'zth-alarms',
        title: 'Тревожные события',
        capsPred: hasCap(Capability.has_multiple_thermometers),
        children: [
            { id: 'power', title: 'Вкл / Выкл' },
            {
                id: 'main_power',
                title: 'Пропадание/появление основного питания',
                capsPred: hasCap(Capability.has_battery),
            },
            { id: 'temperature_alarm', title: 'Температура выше/ниже порога' },
            { id: 'humidity_alarm', title: 'Влажность выше/ниже порога' },
            { id: 'thermometer_malfunction', title: 'Термодатчик недоступен' },
            { id: 'boilerfail', title: 'Авария котла' },
            { id: 'zonealarm', title: 'Срабатывание охранной зоны' },
        ],
    },
    {
        id: 'diagnostics',
        title: 'Диагностика',
        capsPred: hasCap(Capability.has_car_diagnostics),
        children: [{ id: 'ecu_errors', title: 'Ошибки ЭБУ' }],
    },
    {
        id: 'network',
        title: 'Связь',
        require_staff: true,
        children: [
            {
                id: 'connection',
                title: 'Подключение/отключение от сервера',
            },
            { id: 'gps', title: 'Пропадание/появление сигнала GPS' },
            { id: 'gsm', title: 'Пропадание/появление сигнала GSM' },
        ],
    },
    {
        id: 'moving2',
        title: 'Движение',
        capsPred: hasCap(Capability.has_gps),
        children: [
            { id: 'stop', title: 'Остановки' },
            {
                id: 'landmarks',
                title: 'Метки',
                capsPred: hasCap(Capability.can_place_landmarks),
            },
        ],
    },
    {
        id: 'geozones',
        title: 'Геозоны',
        capsPred: branding.geozones
            ? hasCap(Capability.has_autoscan_packets)
            : branding.geozones_in_paid_tariff
                ? hasCap(Capability.has_gps)
                : undefined,
        children: [
            { id: 'EnterGeozone', title: 'Вхождения' },
            { id: 'LeaveGeozone', title: 'Выходы' },
            { id: 'CrossGeozone', title: 'Пересечения' },
            { id: 'OverSpeed', title: 'Превышения скорости' },
        ],
    },
    {
        id: 'service',
        title: 'Сервис',
        children: [
            { id: 'filetransfers', title: 'Загрузка файлов и обновление ПО' },
            { id: 'callsms', title: 'Звонки и SMS' },
            {
                id: 'thermometer_update',
                title: 'Обнаружение термодатчиков',
                capsPred: hasCap(Capability.has_multiple_thermometers),
            },
            {
                id: 'autoscan_touchmemory',
                title: 'Касание ключа водителя',
                capsPred: hasCap(Capability.has_autoscan_packets),
            },
        ],
    },
    {
        id: 'commands_history',
        title: 'Отправленные команды',
        children: [{ id: 'commands', title: 'Команды' }],
    },
];
export const EventDesc = {
    Unknown: {
        filter: 'unknown',
    },
    Stop: {
        filter: 'stop',
    },
    AS_STOP: {
        filter: 'stop',
    },
    EnterGeozone: {
        filter: 'EnterGeozone',
    },
    LeaveGeozone: {
        filter: 'LeaveGeozone',
    },
    CrossGeozone: {
        filter: 'CrossGeozone',
    },
    OverSpeed: {
        filter: 'OverSpeed',
    },
    PowerOn: {
        filter: 'power',
    },
    PowerOff: {
        filter: 'power',
    },
    AS_POWER_ON: {
        filter: 'power',
    },
    AS_POWER_OFF: {
        filter: 'power',
    },
    GPSLost: {
        filter: 'gps',
    },
    AS_GPS_LOST: {
        filter: 'gps',
    },
    GPSFound: {
        filter: 'gps',
    },
    AS_GPS_FOUND: {
        filter: 'gps',
    },
    GSMFound: {
        filter: 'gsm',
    },
    GSMLost: {
        filter: 'gsm',
    },
    AlarmButton: {
        filter: 'alarmbutton',
    },
    connected: {
        filter: 'connection',
    },
    disconnected: {
        filter: 'connection',
    },
    reconnected: {
        filter: 'connection',
    },
    Connect: {
        filter: 'connection',
    },
    CurrentECUErrors: {
        filter: 'ecu_errors',
    },
    SavedECUErrors: {
        filter: 'ecu_errors',
    },
    AS_CUR_ERR: {
        filter: 'ecu_errors',
    },
    AS_SAV_ERR: {
        filter: 'ecu_errors',
    },
    MainPowerLost: {
        filter: 'main_power',
    },
    MainPowerFound: {
        filter: 'main_power',
    },
    GuardOn: {
        filter: 'guard',
    },
    GuardOff: {
        filter: 'guard',
    },
    Z3K_ZoneGuardOn: {
        filter: 'guard',
    },
    Z3K_ZoneGuardOff: {
        filter: 'guard',
    },
    Shock1: {
        filter: 'shock',
    },
    Shock2: {
        filter: 'shock',
    },
    Door: {
        filter: 'alarm',
    },
    Door1: {
        filter: 'alarm',
    },
    Door2: {
        filter: 'alarm',
    },
    Door3: {
        filter: 'alarm',
    },
    Door4: {
        filter: 'alarm',
    },
    Door5: {
        filter: 'alarm',
    },
    Door6: {
        filter: 'alarm',
    },
    HoodTrunk: {
        filter: 'alarm',
    },
    Hood: {
        filter: 'alarm',
    },
    Trunk: {
        filter: 'alarm',
    },
    AutoIgnition: {
        filter: 'autoignition',
    },
    EngineBreakdown: {
        filter: 'autoignition',
    },
    AS_IGNITION_ON: {
        filter: 'autoignition',
    },
    AS_IGNITION_OFF: {
        filter: 'autoignition',
    },
    EngineStarted: {
        filter: 'engine',
    },
    EngineStopped: {
        filter: 'engine',
    },
    SoftwareUpgrade: {
        filter: 'filetransfers',
    },
    Alarm: {
        filter: 'alarm',
    },
    AlarmIgnition: {
        filter: 'alarm',
    },
    AlarmTilt: {
        filter: 'alarm',
    },
    AlarmBrake: {
        filter: 'alarm',
    },
    EngineBlock: {
        filter: 'engineblock',
    },
    Moving: {
        filter: 'alarm',
    },
    Blackout: {
        filter: 'blackout',
    },
    GSMLostAlarm: {
        filter: 'alarm',
    },
    OutCallTone: {
        filter: 'callsms',
    },
    OutCallConnection: {
        filter: 'callsms',
    },
    OutCallEnd: {
        filter: 'callsms',
    },
    InCall: {
        filter: 'callsms',
    },
    InCallConnection: {
        filter: 'callsms',
    },
    InCallEnd: {
        filter: 'callsms',
    },
    InSMS: {
        filter: 'callsms',
    },
    OutSMS: {
        filter: 'callsms',
    },
    ErrorSendSMS: {
        filter: 'callsms',
    },
    DriverCallButton: {
        filter: 'alarmbutton',
    },
    ThermometerUpdate: {
        filter: 'thermometer_update',
    },
    TemperatureHigh: {
        filter: 'temperature_alarm',
    },
    Z3K_TemperatureHigh: {
        filter: 'temperature_alarm',
    },
    TemperatureLow: {
        filter: 'temperature_alarm',
    },
    Z3K_TemperatureLow: {
        filter: 'temperature_alarm',
    },
    ThermometerMalfunction: {
        filter: 'thermometer_malfunction',
    },
    BatteryLow: {
        filter: 'batterylow',
    },
    RadioFOBAdded: {
        filter: 'radiofobadded',
    },
    BoilerFail: {
        filter: 'boilerfail',
    },
    BoilerFailCancel: {
        filter: 'boilerfail',
    },
    Landmark: {
        filter: 'landmarks',
    },
    ZoneAlarm: {
        filter: 'zonealarm',
    },
    ZoneAlarmCancel: {
        filter: 'zonealarm',
    },
    OTFail: {
        filter: 'boilerfail',
    },
    Z3K_OTFail: {
        filter: 'boilerfail',
    },
    Z3K_OTRestore: {
        filter: 'boilerfail',
    },
    GTWFail: {
        filter: 'boilerfail',
    },
    OTFailCancel: {
        filter: 'boilerfail',
    },
    OTLost: {
        filter: 'boilerfail',
    },
    OTFound: {
        filter: 'boilerfail',
    },
    UploadSuccess: {
        filter: 'filetransfers',
    },
    UploadFailed: {
        filter: 'filetransfers',
    },
    ExtSensorWarning: {
        filter: 'alarm',
    },
    ExtSensorAlarm: {
        filter: 'alarm',
    },
    Z3K_RFSensor: {
        filter: 'alarm',
    },
    Z3K_RFSensorRestore: {
        filter: 'alarm',
    },
    Z3K_ZoneAlarm: {
        filter: 'alarm',
    },
    AS_TM: {
        filter: 'autoscan_touchmemory',
    },
    CarInputs: {
        filter: 'carinputs',
    },
    IgnitionOn: {
        filter: 'carinputs',
    },
    IgnitionOff: {
        filter: 'carinputs',
    },
    UserAlarm: {
        filter: 'thermometer_malfunction',
    },
    Z3K_HumidityHigh: {
        filter: 'humidity_alarm',
    },
    Z3K_HumidityLow: {
        filter: 'humidity_alarm',
    },
    AS_ALERT: {
        filter: 'alarmbutton',
    },
    AS_DISTRIB: undefined,
    AS_BATT_ON: {
        filter: 'main_power',
    },
    AS_BATT_OFF: {
        filter: 'main_power',
    },
    UserEvent: undefined,
    Z3K_LinkLost: {
        filter: 'main_power',
    },
    Z3K_LinkRestored: {
        filter: 'main_power',
    },
    Z3K_Leakage: undefined,
    Z3K_ZoneRestore: undefined,
    LogMessage: undefined,
    InfoStaffMessage: {
        filter: 'staff',
    },
    WarningStaffMessage: {
        filter: 'staff',
    },
    LossConnectionBoiler: {
        filter: 'main_power',
    },
    ReconnectingBoiler: {
        filter: 'main_power',
    },
    TargetTemperature: {
        filter: 'commands',
    },
    AddRadiosensors: {
        filter: 'commands',
    },
    ZoneOnGuard: {
        filter: 'commands',
    },
    SelectHeatingMode: {
        filter: 'commands',
    },
    SelectHeatingModeForCircuit: {
        filter: 'commands',
    },
    ChangeWebElementState: {
        filter: 'commands',
    },
    RunScenario: {
        filter: 'commands',
    },
    SetTestPumpOrRelay: {
        filter: 'commands',
    },
    SetTestTap: {
        filter: 'commands',
    },
    ChangeAnalogOutputValue: {
        filter: 'commands',
    },
    Sync_z3k_config: {
        filter: 'commands',
    },
    MaintenanceNotification: undefined,
};
